module.exports = __webpack_public_path__ + "static/img/24.cc8929c4.jpg";